import { Environment } from './environment.model';

export const environment: Environment = {
    production: true,
    environment: 'prod',
    apiUrl: 'https://api.cloud4log-apitest.de/api/v2',
    apiV3Url: 'https://api.cloud4log-apitest.de/api/v3',
    addonsUrl: 'https://apitest.dls.addons.cloud4log.dev/api/v2',
    addonsV3Url: 'https://apitest.dls.addons.cloud4log.dev/api/v3',
    ecmrUrl: 'https://apitest.ecmr.addons.cloud4log.dev/api',
    version: require('../../package.json').version,
    buildDate: require('../../build.json').buildDate,
    defaultLang: 'de',
    availableLanguages: [
        {
            code: 'de',
            label: 'Deutsch',
        },
        {
            code: 'en',
            label: 'English',
        },
        {
            code: 'uk',
            label: 'Ukrainian',
        },
        {
            code: 'bg',
            label: 'Bulgarian',
        },
        {
            code: 'fr',
            label: 'French',
        },
        {
            code: 'it',
            label: 'Italian',
        },
        {
            code: 'nl',
            label: 'Dutch',
        },
        {
            code: 'pl',
            label: 'Polish',
        },
        {
            code: 'ro',
            label: 'Romanian',
        },
        {
            code: 'ru',
            label: 'Russian',
        },
        {
            code: 'es',
            label: 'Spanish',
        },
        {
            code: 'tr',
            label: 'Turkish',
        },
        {
            code: 'hr',
            label: 'Croatian',
        },
        {
            code: 'hu',
            label: 'Hungarian',
        },
        {
            code: 'cz',
            label: 'Czech',
        },
        {
            code: 'lt',
            label: 'Lithuanian',
        },
    ],
    externalSignatureUrl: `/external/signature-pad`,
    externalWalletUrl: `/external/wallet-invite`,
    twoFactorEnabled: true,
    languageSwitcher: true,
    maintenance: false,
    maxFileSize: 15728640,
    oAuthIssuer: 'https://auth.nonprod.cloud4log.dev/realms/dls-apitest',
    oAuthClientId: 'addons-frontend',
    oAuthForceHttps: true,
    managementOAuthAuthority:
        'https://auth.nonprod.cloud4log.dev/realms/devops',
    managementOAuthClientId: 'management-interface-apitest',
    managementOAuthRoleRead: 'mi-read',
    managementOAuthRoleWrite: 'mi-write',
    managementApiUrl: 'https://dashboard.tools.apitest.addons.c4l.tsi-poc.de',
    sentry: {
        dsn: 'https://ff5e5e8998db906095c7789be52237ee@watchtower.cloud4log.com/2',
        enabled: false,
        environment: 'addons-apitest',
        tracesSampleRate: 1.0,
    },
};
